import { BuildFontString } from "./BuildFontString";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_Param4 } from "./XML_Param4";
import { XML_Param5 } from "./XML_Param5";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Scale } from "./XML_Scale";
import { RoundTo3 } from "./RoundTo3";

export function XML_DrawTextPPT(
  textArr,
  x,
  y,
  textColor,
  fontFamily,
  fontSize,
  bold,
  italic,
  underline,
  alignment,
  vAlignment,
  clipRect,
  drawElement,
  layer,
  width = null
) {
  x = XML_ScaleAndShiftX(clipRect.fLeft, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);

  if (width != null) {
    var fs = BuildFontString(fontFamily, fontSize, bold, italic);
  } else {
    var width = XML_Scale(Math.abs(clipRect.fRight - clipRect.fLeft), drawElement, layer);
    var fs = BuildFontString(fontFamily, Math.floor(fontSize * drawElement.scale), bold, italic);
  }
  var height = XML_Scale(Math.abs(clipRect.fTop - clipRect.fBottom), drawElement, layer);

  var makeTextArray = drawElement.MakeText(textArr, width, fs);
  var leftMessage = makeTextArray[0];
  var rightMessage = makeTextArray[1];
  var isJustified = makeTextArray[2];
  if (isJustified) alignment = "left";

  //all these lines are omitted, theMessage is the only one we need.
  XML_Param4("t", RoundTo3(x), RoundTo3(y), RoundTo3(width), RoundTo3(height), drawElement);
  var biString = "";
  if (italic) biString = biString + "I ";
  if (bold) biString = biString + "B ";
  if (underline) biString = biString + "U ";
  fontSize = XML_Scale(fontSize, drawElement, layer);
  fontSize = Math.max(fontSize, 1);
  XML_Param5("f", fontFamily, biString, textColor, RoundTo3(fontSize), alignment, drawElement);
  XML_AddSingle(leftMessage, "s", drawElement);

  if (isJustified) {
    XML_Param4("t", RoundTo3(x), RoundTo3(y), RoundTo3(width), RoundTo3(height), drawElement);
    XML_Param5("f", fontFamily, biString, textColor, RoundTo3(fontSize), "right", drawElement);
    XML_AddSingle(rightMessage, "s", drawElement);
  }
}
